import React from "react";
import { Document, Page, Text, View, StyleSheet,Image } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 12, fontFamily: "Helvetica", color: "#101828" },
  heading: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
    color: "#003149",
  },
  recordGroup: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 6,
  },
  label: { color: "#344054", fontWeight: "bold" },
  value: { color: "#101828" },
});

const ExportAutomatedPDF = ({ data,logo }) => {
  const { t } = useTranslation();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
            {logo && (
          <Image
            src={logo}
            style={{ width: 120, alignSelf: "center", marginBottom: 10 }}
          />
        )}
        <Text style={styles.heading}>
          {t("automatedDocuments.title")}
        </Text>

        {data.map((row, index) => (
          <View key={index} style={styles.recordGroup}>

            <View style={styles.row}>
              <Text style={styles.label}>{t("automatedDocuments.table.id")}:</Text>
              <Text style={styles.value}>{row.id}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("automatedDocuments.table.date")}:</Text>
              <Text style={styles.value}>{row.date}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("automatedDocuments.table.name")}:</Text>
              <Text style={styles.value}>{row.name}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("automatedDocuments.table.department")}:</Text>
              <Text style={styles.value}>{row.department}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("automatedDocuments.table.work_schedule")}:</Text>
              <Text style={styles.value}>{row.workSchedule}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("automatedDocuments.table.mobile")}:</Text>
              <Text style={styles.value}>{row.mobile}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("automatedDocuments.table.email")}:</Text>
              <Text style={styles.value}>{row.email}</Text>
            </View>

          </View>
        ))}

      </Page>
    </Document>
  );
};

export default ExportAutomatedPDF;
